import { render, staticRenderFns } from "./SelectedMsgBox.vue?vue&type=template&id=09d9a2a5&scoped=true"
import script from "./SelectedMsgBox.vue?vue&type=script&lang=js"
export * from "./SelectedMsgBox.vue?vue&type=script&lang=js"
import style0 from "./SelectedMsgBox.vue?vue&type=style&index=0&id=09d9a2a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d9a2a5",
  null
  
)

export default component.exports